/**
 * Base axios configuration applied once at app boot.
 *
 * The native-auth provider (NativeAuthProvider) owns the Authorization header
 * and the 401 refresh interceptor; here we only set the API base URL and the
 * default Accept header.
 */
export function setupAxios(axios: any) {
    axios.defaults.headers.Accept = 'application/json';
    const {hostname} = window.location;

    axios.defaults.baseURL =
        hostname === 'localhost'
            ? window.location.origin // same-origin, proxied via src/setupProxy.js to avoid CORS in local dev; non-empty so relative 'api/...' paths resolve from the root
            : 'https://' + hostname;
}
